if (!customElements.get('lang-switcher')) {
	class LangSwitcher extends HTMLElement {
		constructor() {
			super()
            this.updateLinks()
		}

		updateLinks() {
			// Look for href rel="alternate" links that starts with the domain of the link
			const links = this.querySelectorAll('a')
			links.forEach((link) => {
				const href = link.getAttribute('href')
				const relAlternate = document.querySelector(
					`link[rel="alternate"][hreflang][href^="${href}"]`
				)
				if (relAlternate) {
					link.setAttribute('href', relAlternate.getAttribute('href'))
				}
			})
		}
	}
	customElements.define('lang-switcher', LangSwitcher)
}
